/**
 * Enum for Kds Order Priority.
 * @readonly
 * @enum {String} KdsOrderPriorityEnum
 */

const KdsOrderPriorityEnum = {
  NEXT    : 'next',
  PREVIOUS: 'previous',
  FIRST   : 'first',
  LAST    : 'last'
}

export default KdsOrderPriorityEnum
